<template>
    <div class="city-sales-info">
        <template v-if="currentCityInfo">
            <h3 class="row-header">
                采购信息
            </h3>
            <xx-form
                ref="purchase-form"
                :model="currentCityInfo"
                :rules="rules"
                label-width="135px"
                label-suffix="："
                class="max-width-750 w-full"
            >
                <!-- 加工状态：原料/成品 展示 -->
                <xx-form-item
                    label="城市采购价(元)"
                    prop="purchasePrice"
                >
                    <el-input-number
                        v-model="currentCityInfo.purchasePrice"
                        :controls="false"
                        :disabled="MixinJudgeRejectedAttrsDisabled('purchasePrice')"
                        style="width: 100% !important"
                    />
                </xx-form-item>
                <xx-form-item
                    label="城市生产商"
                >
                    <ManufactureNameSelectInput
                        :key="currentCityInfo.manufacturerId"
                        :value="currentCityInfo.manufacturerId + ''"
                        :manufacture-name="currentCityInfo.manufacturerName || ''"
                        :show-add-producer="false"
                        :disabled="MixinJudgeRejectedAttrsDisabled('manufacturerId')"
                        @manufactureIdChanged="manufactureIdChanged"
                        @manufactureNameChanged="manufactureNameChanged"
                    />

                    <div class="el-form-item__description">
                        <div>1、绑定标签上唯一生产商</div>
                        <div>2、当标签上多个生产商，绑定检测报告上的“标称生产单位” </div>
                        <div>
                            3、找不到生产商？请前往<xx-link
                                path="https://vss.baobaoaichi.cn/supplierSku/producer/edit.html?action=add"
                            >
                                新增生产商
                            </xx-link>
                        </div>
                        <example-pic type="manufacturer" />
                    </div>
                </xx-form-item>
                <xx-form-item
                    label="配送方式"
                    prop="shippingType"
                >
                    <!-- 加工品状态：原料 和 成品 和 加工品，配送方式options差异处理 -->
                    <xx-select
                        v-model="currentCityInfo.shippingType"
                        :list="shippingTypeOptions"
                        :disabled="MixinJudgeRejectedAttrsDisabled('shippingType')"
                        style="width: 100% !important"
                    />
                </xx-form-item>
                <xx-form-item
                    v-if="showRdc"
                    label="仓"
                    prop="rdcId"
                >
                    <rdc-select
                        v-model="currentCityInfo.rdcId"
                        :city-ids="[+currentCityId]"
                        :use-permission="false"
                        :disabled="MixinJudgeRejectedAttrsDisabled('rdcId')"
                        style="width: 100% !important"
                    />
                </xx-form-item>
            </xx-form>

            <el-form
                label-width="135px"
                label-suffix="："
                class="max-width-750 w-full"
            >
                <NewExtAttrsWrap
                    ref="purchaseExtAttr"
                    :key="currentCityId"
                    :category-id="categoryId"
                    :bg-category-id="bgCategoryId"
                    :selected-attr-list="currentCityInfo.citySkuAttributes"
                    :attr-type="4"
                    :is-filter-blank-ext="false"
                    :special-ext-attr-ids="[20020]"
                    mode="edit"
                    :default-disabled="MixinJudgeRejectedAttrsDisabled('extAttrCityPurchase')"
                    :unique-flag="currentCityId"
                    show-value-image
                    :is-discount-sku="isDiscountSku"
                    :focused-marking-list="focusAttrData.extAttrList || []"
                    @selectedExtAttrList="onExtAttrSelected"
                />
            </el-form>
        </template>
        <template v-if="currentCityInfo && !isMaterial && !isSupplies">
            <h3 class="row-header">
                销售信息
            </h3>
            <xx-form
                ref="buy-form"
                :model="currentCityInfo"
                :rules="rules"
                label-width="135px"
                label-suffix="："
                class="max-width-750 w-full"
            >
                <xx-form-item
                    label="售价(元)"
                    prop="sellPrice"
                >
                    <el-input-number
                        v-model="currentCityInfo.sellPrice"
                        style="width: 100% !important"
                        :controls="false"
                        :disabled="MixinJudgeRejectedAttrsDisabled('sellPrice')"
                    />
                </xx-form-item>
            </xx-form>
        </template>
    </div>
</template>

<script>
import ManufactureNameSelectInput from 'components/ManufactureNameSelectInput';
import {
    finishedEnum,
    materialEnum,
    shipTypeOptionsInProcessed,
    shipTypeOptionsInMaterial,
    shipTypeOptionsInFinished,
} from 'utils/dataMap';
import { getCategoryIdBylevel } from 'utils/category';
import NewExtAttrsWrap from 'components/NewExtAttrsWrap';
import RdcSelect from '../components/RdcSelectByManageCity';
import { shared } from '../shareState';
import { getRules } from './config';
import MixinJudgeRejectedAttrsDisabled from '../mixins/rejectedDisabled';
import ExamplePic from '../components/ExamplePicDialog';

const RDC_SHIP_LIST = [20, 50, 60, 70];

export default {
    name: 'Edit',
    components: {
        RdcSelect,
        ManufactureNameSelectInput,
        ExamplePic,
        NewExtAttrsWrap,
    },
    mixins: [MixinJudgeRejectedAttrsDisabled],
    props: {
        currentCityInfo: {
            type: Object,
            default: () => {},
        },
        currentCityId: {
            type: Number,
            default: 0,
        },
        createInfoModel: {
            type: Object,
            default: () => {},
        },
        baseInfoModel: {
            type: Object,
            default: () => {},
        },
        // 分类品类是物资品
        isSupplies: {
            type: Boolean,
            default: false,
        },
        // 单位列表
        originUnitList: {
            type: Array,
            default: () => [],
        },
        mode: {
            type: String,
            default: 'edit',
        },
        // 是否是b货
        isDiscountSku: {
            type: Boolean,
            default: false,
        },
        // c端展示重点属性
        focusAttrData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            shipTypeOptionsInProcessed,
            shipTypeOptionsInMaterial,
            shipTypeOptionsInFinished,
            rules: {},
        };
    },
    computed: {
        // 加工状态：原料
        isMaterial() {
            return this.createInfoModel.skuType === materialEnum;
        },
        // 加工状态：成品
        isFinished() {
            return this.createInfoModel.skuType === finishedEnum;
        },
        // 是否展示仓逻辑：【配送方式】为 直送到仓，配送到站 20；直送到仓，越库到站 50；直送到加工仓 70；加工仓自加工，配送到站 60
        showRdc() {
            if (!this.currentCityInfo) return false;
            return RDC_SHIP_LIST.includes(this.currentCityInfo.shippingType);
        },
        categoryId() {
            return this.createInfoModel.categoryId;
        },
        bgCategoryId() {
            return this.createInfoModel.bgCategoryId;
        },
        categoryIdLevel2() {
            return getCategoryIdBylevel(this.categoryId, 2, shared.categoryTreeData);
        },

        // 配送方式下拉列表
        // 加工品状态：原料 和 成品 和 加工品，配送方式options差异处理
        shippingTypeOptions() {
            if (this.isMaterial) return shipTypeOptionsInMaterial;
            if (this.isFinished) return shipTypeOptionsInFinished;
            // if (this.isProcessed) return shipTypeOptionsInProcessed;
            return [];
        },
        // 主条形码生产商
        manufacturerId() {
            const target = (this.baseInfoModel.skuCodeList || []).find((item) => item.mainCodeFlag);
            if (!target) return '';
            return target.manufactureId || '';
        },
    },
    watch: {
        'currentCityInfo.supplierId': {
            handler(val) {
                if (val) this.getSupplierQuantity();
            },
            immediate: true,
        },
        'currentCityInfo.manufacturerId': {
            handler(val) {
                if (val) this.getSupplierQuantity();
            },
            immediate: true,
        },
    },
    methods: {
        init() {
            // 处理特殊情况：select options和value不匹配的情况
            this.handleSelectMatchValue();
            // 处理默认值
            this.getDefaultValue();
            // 在这里rules初始化，保证每次进入时，都加载最新校验规则
            this.rules = getRules(this);
            // 兜底处理，前面步骤有联动的场景，需要清理数据，保证参数准确
            // 比如条件：【散装且购买步长单位=基础单位】才支持配置【履约浮动范围】，但当散装->标品，则需要清理掉服务端返回的履约浮动范围。类似场景类似操作。
            // 但要保证清理的条件的正确
            this.cleanCurrentCityInfo();
            // 清理校验提示
            this.$nextTick(() => {
                this.clearValid();
            });
        },
        clearValid() {
            if (this.$refs['purchase-form']) this.$refs['purchase-form'].clearValidate();
            if (this.$refs['buy-form']) this.$refs['buy-form'].clearValidate();
        },
        handleSelectMatchValue() {
            // case1: 购买步长单位sellUnitId，散装和标品不同，单位options不同，可能会导致匹配失败
            // 如果value没有在options中，简单粗暴 直接赋值单位options中第一个，如果没有单位options，清空value
            const { shippingType } = this.currentCityInfo;
            // 加工状态 影响配送方式，可能导致无法展示名称
            if (shippingType) {
                const target = this.shippingTypeOptions.find((opt) => opt.value === +shippingType);
                if (!target) {
                    this.currentCityInfo.shippingType = null;
                }
            }
        },
        onSelectChange(id, item, key) {
            this.currentCityInfo[key] = item.name;
        },
        // 生产商id
        manufactureIdChanged(id) {
            this.currentCityInfo.manufacturerId = id;
        },
        // 生产商名称
        manufactureNameChanged(name) {
            this.currentCityInfo.manufacturerName = name;
        },
        // 选择已有SKU时，需要获取供应商，生产商资质信息，否则跳过
        async getSupplierQuantity() {
            if (!this.createInfoModel.skuBaseId || !this.currentCityInfo) return;
            const params = {
                page: {
                    offset: 0,
                    limit: 1,
                },
                supplierId: this.currentCityInfo.supplierId,
                producerId: this.currentCityInfo.manufacturerId || undefined,
                skuId: this.createInfoModel.skuBaseId,
            };
            const { total } = await this.$service.getNewSkuLicense(params);
            // total > 0则表示供应商已存在资质，不需要第四步去填写，否则需要填写
            this.currentCityInfo.isSupplierExistQualification = Boolean(total);
        },
        // 处理默认值
        getDefaultValue() {
            // 如果没有生产商，则默认值取基础信息 主条形码的生产商id
            if (this.isMaterial || this.isFinished) {
                if (!this.currentCityInfo.manufacturerId || this.currentCityInfo.manufacturerId === -1) {
                    this.currentCityInfo.manufacturerId = this.manufacturerId;
                }
            }
        },
        buyInfoDataReset() {
            Object.assign(this.currentCityInfo, {
                sellPrice: null,
            });
        },
        cleanCurrentCityInfo() {
            // 原料/物资 售卖信息数据重置
            if (this.isMaterial || this.isSupplies) {
                this.buyInfoDataReset();
            }
        },
        async validate() {
            const {
                isMaterial, isSupplies,
            } = this;
            let validResult = false;
            // 物资/原料，不校验售卖信息
            const forms = (isMaterial || isSupplies) ? ['purchase-form'] : ['purchase-form', 'buy-form'];
            try {
                const valids = await Promise.all(forms.map((ref) => this.$refs[ref].validate()));
                const purchasExtValid = this.$refs.purchaseExtAttr.validate();
                valids.push(purchasExtValid);
                validResult = valids.every((valid) => valid === true);
            } catch (error) {
                // pass
                console.warn(error);
            }
            return validResult;
        },

        onExtAttrSelected(data) {
            if (!this.currentCityInfo.citySkuAttributes || !data.length) this.currentCityInfo.citySkuAttributes = [];
            data.forEach((selectedItem) => {
                const target = this.currentCityInfo.citySkuAttributes.find((item) => item.attrId === selectedItem.attrId);
                if (target) {
                    target.selectedValues = selectedItem.selectedValues;
                } else {
                    this.currentCityInfo.citySkuAttributes.push(selectedItem);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.city-sales-info {

}
.common-w {
    width: 100px;
}
.select-input-w {
    width: 200px;
    .show-btn {
        width: 60px;
        padding: 0;
        text-align: center;
        overflow: hidden;
    }
}
.unit-w {
    width: 100px;
}
// .max-width {
//     max-width: 1200px;
// }
/deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #EB2F3C !important;
}
.max-width-750 {
    max-width: 750px;
}
.w-full {
    width: 100%;
}
</style>
